module.exports = __webpack_public_path__ + "img/productSatellite_11.e5793092.png";